import React from "react";

// Confidential-access dropdown for the AI Assistant engine (B-CONF-3).
// Simulates the production JWT claim in dev. Only rendered in dev uiMode.
//
// The value rides the socket handshake (auth.confidentialAccess) and is read by the
// /ai-assistant namespace middleware, then threaded through to the agent's tenant context.
// When "No", confidential records are hidden silently (B-CONF-1).
//
// Props:
//   confidentialAccess : boolean
//   onChange           : (boolean) => void

export default function ConfidentialAccessToggle({ confidentialAccess, onChange }) {
  return (
    <div className="flex gap-2 items-center">
      <label className="text-xs text-gray-500">Confidential:</label>
      <select
        value={confidentialAccess ? "yes" : "no"}
        onChange={(e) => onChange(e.target.value === "yes")}
        className="text-xs border border-gray-300 rounded px-2 py-1 bg-gray-50 hover:border-gray-400 focus:outline-none focus:border-blue-500"
      >
        <option value="no">No</option>
        <option value="yes">Yes (granted)</option>
      </select>
    </div>
  );
}
